module.exports = __webpack_public_path__ + "img/DSC_9341.6fc9bbd7.jpg";